import React from "react";
import loginRequiredIcon from "../../images/loginRequired.svg";
import noAccessIcon from "../../images/noAccess.svg";
import expiredIcon from "../../images/expired.svg";
import notPublishedIcon from "../../images/notPublished.svg";
import { gotoPromotions, handleLogin } from "../../utils/common";

const Exceptions: React.FC<any> = (props) => {
  const { status, loginState } = props;

  if (status === "activity_expired" || status === "activity_deactivated") {
    const msg = status === "activity_expired" ? "此活动已结束" : "此活动尚未激活";

    return (
      <div className="exceptionWrapper">
        <div>
          <img src={expiredIcon} alt="expired"></img>
        </div>
        <div className="msg">{msg}</div>
        <div className="subMsg">
          <span>请点击</span>
          <span className="textLink" onClick={() => gotoPromotions(loginState)}>促销商城</span>
          <span>查看更多活动</span>
        </div>
      </div>
    );
  }
  if (status === "activity_not_published") {
    return (
      <div className="exceptionWrapper">
        <div>
          <img src={notPublishedIcon} alt="not published"></img>
        </div>
        <div className="msg">此活动尚未开始</div>
        <div className="subMsg">
          <span>请点击</span>
          <span className="textLink" onClick={() => gotoPromotions(loginState)}>促销商城</span>
          <span>查看更多活动</span>
        </div>
      </div>
    );
  }
  if (status === "activity_login_required") {
    return (
      <div
      className="exceptionWrapper"
      >
        <div>
          <img src={loginRequiredIcon} alt="login in to access"></img>
        </div>
        <div className="msg">请先登录方可参加此活动</div>
        <div className="subMsg">
          {/* <span>{count}</span> */}
          <span>点击</span>
          <span className="textLink" onClick={handleLogin}>登录页面</span>
          <span>进行登录</span>
        </div>
      </div>
    );
  }
  if (status === "activity_no_permission") {
    return (
      <div className="exceptionWrapper">
        <div>
          <img src={noAccessIcon} alt="no access"></img>
        </div>
        <div className="msg">感谢您的关注！该活动仅限指定用户参与</div>
        <div className="subMsg">
          <span>您可以点击</span>
          <span className="textLink" onClick={() => gotoPromotions(loginState)}>促销商城</span>
          <span>查看更多活动</span>
        </div>
      </div>
    );
  }
  return <div className="exceptionWrapper">{'获取活动详情失败'}</div>;
};

export default Exceptions;
